import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login/Login";
import SubRouter from "@/components/SubRouter";
import Admin from "@/components/Admin/Admin";
import LiveRun from "@/components/LiveRun/LiveRun";
import PastRun from "@/components/LiveRun/Race/PastRun";
import ScheduledRuns from "@/components/LiveRun/Race/ScheduledRuns";
import Medal from "@/components/LiveRun/Race/Medal";
import Settings from "@/components/LiveRun/Race/Settings";
import SystemSettings from "@/components/LiveRun/Race/SystemSettings";
import TP from "@/components/LiveRun/Race/TP";
import ARTD from "@/components/LiveRun/Race/AR&TD";
import Feedback from "@/components/LiveRun/Race/Feedback";
import PromoCodes from "@/components/LiveRun/Race/PromoCodeManager/PromoCodes";
import FirebaseStats from "@/components/LiveRun/FirebaseStats/FirebaseStats";
import MongoExplorer from "@/components/LiveRun/Race/MongoExplorer";

import ActiveRuns from "@/components/LiveRun/Race/ActiveRuns";

import AllRunners from "@/components/LiveRun/Race/All";
import AllRunnersWithRunCompleted from "@/components/LiveRun/Race/AllWithRunCompleted";
import AllLuckyLiveRunners from "@/components/LiveRun/Race/AllLuckyLiveRunners";

import RaceDetail from "@/components/LiveRun/Race/RaceDetail";
import GoogleMap from "@/components/LiveRun/Race/GoogleMap";
import RunnerData from "@/components/LiveRun/Race/RunnerData";
import Race from "@/components/LiveRun/Race";
import RaceResume from "@/components/LiveRun/RaceResume";
import AddRace from "@/components/Races/Create";
import ListRace from "@/components/Races/List";
import UpdateRace from "@/components/Races/Update";
import Error403 from "@/components/pages/403";
import RunnerManager from "@/components/RunnerManager";
import TrainerManager from "@/components/TrainerManager";
import AllTrainers from "@/components/LiveRun/Race/TrainerManager/All";
import AddTrainer from "@/components/LiveRun/Race/TrainerManager/Add";
import EditTrainer from "@/components/LiveRun/Race/TrainerManager/Edit";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/admin/live-run",
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/admin",
      component: Admin,
      meta: { auth: true },
      children: [
        {
          path: "live-run",
          component: SubRouter,
          children: [
            {
              path: "/",
              component: LiveRun,
            },
            {
              path: "race/:raceId",
              component: Race,
              name: "race",
              props: true,
            },
            {
              path: "race/:raceId/resume",
              component: RaceResume,
            },
          ],
        },
        {
          path: "past-run",
          component: SubRouter,
          children: [
            {
              path: "/",
              component: PastRun,
            },
            {
              path: "race/:raceId",
              component: PastRun,
              name: "past-run-firebase",
              props: true,
            },
            {
              path: "detail/:raceId",
              component: RaceDetail,
              name: "past-run",
            },
          ],
        },
        {
          path: "scheduled-runs",
          component: ScheduledRuns,
        },
        {
          path: "medal",
          component: Medal,
        },
        {
          path: "settings",
          component: Settings,
        },
        {
          path: "system-settings",
          component: SystemSettings,
        },
        {
          path: "TP",
          component: TP,
        },
        {
          path: "AR&TD",
          component: ARTD,
        },
        {
          path: "active-run",
          component: ActiveRuns,
        },

        {
          path: "detail/:raceId",
          component: RaceDetail,
        },

        {
          path: "races",
          component: SubRouter,
          children: [
            {
              path: "/",
              component: ListRace,
            },
            {
              path: "add",
              component: AddRace,
            },
            {
              path: "edit/:raceId",
              component: UpdateRace,
            },
          ],
        },
        // {
        //   path: 'allrunners',
        //   component: AllRunners
        // },
        {
          path: "runners",
          component: RunnerManager,
          children: [
            {
              path: "allrunners",
              component: AllRunners,
            },
            {
              path: "with-run-completed",
              component: AllRunnersWithRunCompleted,
            },
            {
              path: "all-lucky-liverunners",
              component: AllLuckyLiveRunners,
            },
          ],
        },
        {
          path: "trainers",
          component: TrainerManager,
          children: [
            {
              path: "",
              component: AllTrainers,
            },
            {
              path: "add",
              component: AddTrainer,
            },
            {
              path: "edit/:id",
              component: EditTrainer,
            },
          ],
        },
        {
          path: "feedback",
          component: Feedback,
        },
        {
          path: "promo-codes",
          name: "promo-codes",
          component: PromoCodes,
        },
        {
          path: "logs",
          name: "logs",
          component: () => import("@/components/Logs/Logs.vue"),
        },
        {
          path: "firebase-stats",
          name: "firebase-stats",
          component: FirebaseStats,
        },
        {
          path: "mongodb",
          name: "mongodb",
          component: MongoExplorer,
        },
      ],
    },
    {
      path: "/runner/:runnerId",
      name: "runner-data",
      props: true,
      component: RunnerData,
    },
    {
      path: "/map/:raceId/:runnerId",
      name: "google-map",
      props: true,
      component: GoogleMap,
    },
    {
      path: "/403",
      name: "Error403",
      component: Error403,
    },
    {
      path: "*",
      redirect: { path: "/admin" },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js